import React from "react";

import Hero from "components/Hero";

export default function LegalPrivacy() {
	window.scrollTo(0, 0);
	document.title = "Privacy Policy || Jozini Municipality";

	return (
			<Hero
				subheading="Privacy Policy"
				title="Lorem ipsum dolor mit"
				description="Minima dolorum vero quas ullam exercitationem animi. Soluta dicta excepturi temporibus assumenda."
				backgroundImage={require("images/page-title.jpg")}
				hideAppointmentButton
			/>
	);
}